import EventsComponent from "../../../../components/events/EventsComponent.vue"
import ManageEvent from "../../../../components/events/ManageEvent.vue"
import InviteeDepositsDue from "../../../../components/events/InviteeDepositsDue.vue"
import ManageVenueDetails from "../../../../components/events/ManageVenueDetails.vue"

export default [
    {
        path: '/invitee-deposits-due',
        name: 'InviteeDepositsDue',
        meta: { layout: 'mystagit' },
        component: InviteeDepositsDue,
    },
    {
        path: '/venue-details',
        name: 'VenueDetails',
        meta: { layout: 'mystagit' },
        component: ManageVenueDetails,
    },
    {
        path: '/events',
        redirect: '/events/unbooked',
    },
    {
        path: '/events/unbooked',
        name: 'UnbookedEvents',
        meta: { layout: 'mystagit', view: 'unbooked' },
        component: EventsComponent,
    },
    {
        path: '/events/booked',
        name: 'BookedEvents',
        meta: { layout: 'mystagit', view: 'booked' },
        component: EventsComponent,
    },
    {
        path: '/events/past',
        name: 'PastEvents',
        meta: { layout: 'mystagit', view: 'past' },
        component: EventsComponent,
    },
    {
        path: '/events/cancelled',
        name: 'CancelledEvents',
        meta: { layout: 'mystagit', view: 'cancelled' },
        component: EventsComponent,
    },
    {
        path: '/events/closeoffs',
        name: 'CloseOffEvents',
        meta: { layout: 'mystagit', view: 'closeoff' },
        component: EventsComponent,
    },
    {
        path: '/events/:event_id/manage_event',
        name: 'ManageEvent',
        meta: { layout: 'mystagit', company_record: { type: 'event', param: 'event_id' } },
        component: ManageEvent,
    },
]